/** SHA-256 esadecimale dei byte di un Blob: lo stesso hash che il server calcola sui byte ricevuti (F0) e il recorder scrive nel bundle. */
export async function sha256Hex(blob: Blob): Promise<string> {
  const digest = await crypto.subtle.digest('SHA-256', await blob.arrayBuffer());
  return Array.from(new Uint8Array(digest), (b) => b.toString(16).padStart(2, '0')).join('');
}
